<script setup lang="ts">
import CanvasButton from "@/components/canvas/CanvasButton.vue";
import { trackSelection } from "@/analytics/drawing-analytics";
import { Facade } from "@/drawing";

/**
 * Quart de tour horaire de l'image sélectionnée, autour de son centre. Filet de
 * sécurité quand une photo arrive dans le mauvais sens (orientation mal
 * détectée à la prise de vue).
 */
function rotate() {
  if (!Facade.isInitialized) return;
  if (Facade.images.rotateSelected(-90)) {
    trackSelection("image_rotated");
  }
}
</script>

<template>
  <CanvasButton
    phosphor-icon="arrow-clockwise"
    :tooltipTitle="$t('canvas:selection.rotateImage.tooltip.title')"
    :tooltipText="$t('canvas:selection.rotateImage.tooltip.text')"
    @click="rotate"
  />
</template>
